import React from 'react'

import { CenterInfoPanel } from 'Components/layout'
import { Panel } from 'Components/readonly'

const LoggedOutPage = () => {
  return (
    <CenterInfoPanel>
      <Panel>
        <h3>Du är nu utloggad.</h3>
        <p>
          <a href="/">Logga in igen</a>
        </p>
      </Panel>
    </CenterInfoPanel>
  )
}

export default LoggedOutPage
